import WasmController from "react-lib/frameworks/WasmController";

import moment from "moment";

import ConstanceView from "issara-sdk/apis/ConstanceView_core";
import DoctorDetail from "issara-sdk/apis/DoctorDetail_core";
import EncounterDetail from "issara-sdk/apis/EncounterDetail_core";
import EncounterList from "issara-sdk/apis/EncounterList_core";
import EncounterMedicalRecordList from "issara-sdk/apis/EncounterMedicalRecordList_core";
import ScannedDocumentList from "issara-sdk/apis/ScannedDocumentList_core";

import UserDetailAPIView from "issara-sdk/apis/UserDetailAPIView_users";
import UserEmployeeDetailAPIView from "issara-sdk/apis/UserEmployeeDetailAPIView_users";
import UserList from "issara-sdk/apis/UserList_users";

import AdverseReactionList from "issara-sdk/apis/AdverseReactionList_apps_ADR";

import DrugOrderItemList from "issara-sdk/apis/DrugOrderItemList_apps_TPD";

import RehabDeviceSlotList from "issara-sdk/apis/RehabDeviceSlotList_apps_RHB";
import RehabImageDetail from "issara-sdk/apis/RehabImageDetail_apps_RHBM";
import RehabOrderActionLogList from "issara-sdk/apis/RehabOrderActionLogList_apps_RHB";
import RehabOrderBillItemDetail from "issara-sdk/apis/RehabOrderBillItemDetail_apps_RHB";
import RehabOrderBillItemList from "issara-sdk/apis/RehabOrderBillItemList_apps_RHB";
import RehabOrderDetail from "issara-sdk/apis/RehabOrderDetail_apps_RHB";
import RehabOrderHistoryList from "issara-sdk/apis/RehabOrderHistoryList_apps_RHB";
import RehabOrderItemDetail from "issara-sdk/apis/RehabOrderItemDetail_apps_RHB";
import RehabOrderList from "issara-sdk/apis/RehabOrderList_apps_RHB";
import RehabPlanDetail from "issara-sdk/apis/RehabPlanDetail_apps_RHB";
import RehabPlanItemDetail from "issara-sdk/apis/RehabPlanItemDetail_apps_RHB";
import RehabPlanItemTotalDetail from "issara-sdk/apis/RehabPlanItemTotalDetail_apps_RHB";
import RehabPlanList from "issara-sdk/apis/RehabPlanList_apps_RHB";

import PatientAppointmentUpdate from "issara-sdk/apis/PatientAppointmentUpdate_apps_QUE";
import PatientAppointmentView from "issara-sdk/apis/PatientAppointmentView_apps_QUE";

import DrugOrderItemHistorySerializer from "issara-sdk/types/DrugOrderItemHistorySerializer_apps_TPD";
import ScannedDocumentListSerializer from "issara-sdk/types/ScannedDocumentListSerializer_core";

import getPdfMake from "react-lib/appcon/common/pdfMake";

import { GetStaffName } from "react-lib/apps/Scheduling/SchedulingInterface";

import FormPhysicalTherapyCertificate from "./pdfForm/FormPhysicalTherapyCertificate";
import FormPhysicalTherapySchedule from "./pdfForm/FormPhysicalTherapySchedule";

import AppointmentDetail from "issara-sdk/apis/AppointmentDetail_apps_APP";

import * as RehabDevice from "./sequence/RehabDevice";

import { calculateAgeAndDOB, SetErrorMessage } from "../common/CommonInterface";
import { formatAllergy, formatDoctorName } from "../PHV/PHVInterface";

import { beStringToAdString, formatDate, formatDateToYYYYMMDD } from "react-lib/utils/dateUtils";

export type RehabPlanType = {
  id?: number;
  created?: string;
  diagnosis?: Diagnosis;
  encounter: number;
  encounter_type: string;
  goal: string;
  items: RehabPlanItemDetailType[];
  next: any;
  order: Record<string, any> | null;
  order_by: { id: number; name: string };
  order_by_name?: string;
  order_receive_by_name?: string;
  precaution: string[];
  previous: any;
  problem: string;
  total: number;
};

export type RehabPlanItemDetailType = {
  id: number;
  appointment?: {
    date: string;
    no: number;
    rehab_order_id: number;
    rehab_order_item_id: number;
    rehab_plan_item_id: number;
  }[];
  appointments?: Record<string, any>[];
  canceled_reason: string;
  canceled_user_name: string;
  detail: string;
  divisions: number[];
  duration: number;
  edited: string;
  frequency: number;
  icd9_code: string;
  icd9_type: "PRIMARY" | "SECONDARY";
  icd9cm: number;
  icd9cm_med_term: number;
  icd9Data?: Record<string, any> | null;
  icd9Table: any[];
  images?: RehabImageType[];
  is_continue: boolean;
  medical_description: string;
  name?: string;
  performed?: {
    date: string;
    no: number;
    rehab_order_id: number;
    rehab_order_item_id: number;
    rehab_plan_item_id: number;
  }[];
  performed_count?: number;
  productName?: string;
  rehabilitation: number;
  status: "C" | "P" | "X";
  to_department_for_doctor: number;
  to_department_for_doctor_changed?: boolean;
  to_department_for_doctor_name?: string;
  to_department_for_physiotherapist?: number;
  to_department_for_physiotherapist_name?: string;
  total_for_doctor: number;
  total_for_doctor_changed?: boolean;
  total_for_physiotherapist: number;
};

export type RehabImageType = {
  id?: number;
  file?: string;
  file_name?: string;
  image: File | string;
  is_original?: boolean;
  is_overlay?: boolean;
};

export type RehabOrderType = {
  id: number;
  appointment_date: any;
  assessment: string;
  bill_items: RehabOrderBillType[];
  created: string;
  data: Partial<{
    ScannedDocument_id: number[];
    ScannedDocument_name: Record<string, string>;
  }>;
  encounter: number;
  encounter_number: string;
  endDate?: string;
  endTime?: string;
  finish: string;
  goal: string;
  items: RehabOrderItemType[];
  objective: string;
  order_perform_by: number | null;
  order_perform_by_fullname: string;
  order_perform_time: string;
  order_status: string;
  other_examination: string;
  out_perform_div: number;
  post_treatment_evaluation: string;
  principal_procedure?: Procedure;
  procedure?: {
    principle: {
      id?: number;
      icd10_id: number | null;
      icdcode: string;
      icdterm: string;
      medterm: any;
    } | null;
    secondary: {
      id?: null;
      icd10_id: number | null;
      icdcode: string;
      icdterm: string;
      medterm: any;
    }[];
  };
  recommendation_education: string;
  result: string;
  secondary_procedure?: Procedure[];
  start: string;
  startDate?: string;
  startTime?: string;
  status_name: string;
  subjective: string;
};

export type RehabOrderItemType = {
  id: number;
  diagnosis?: Diagnosis;
  no: number;
  plan_item: number;
  plan_item_detail?: RehabPlanType["items"][number];
  product: number;
  quantity: string;
};

export type RehabOrderBillType = {
  id?: number;
  is_paid?: boolean;
  order: number | null;
  price?: number | string;
  product: number | null;
  product_name?: string;
  quantity: number | string;
};

export type RehabOrderGroupType = Omit<RehabOrderType, "items"> & {
  items: RehabOrderGroupItemType[];
};

export type RehabOrderGroupItemType = Diagnosis & {
  treatments: {
    id: number;
    diagnosis: Diagnosis;
    no: number;
    plan_item: number;
    plan_item_detail?: RehabPlanItemDetailType & { name?: string };
    product: any;
    quantity: number;
  }[];
};

export type RehabHistoryDetailType =
  | (RehabOrderGroupType & {
      documents: ScannedDocumentListSerializer[];
      medications: DrugOrderItemHistorySerializer[];
    })
  | null;

type Procedure = {
  id: number | null;
  detail: string;
  emr: number;
  icd9cm: number | null;
  icd9cm_code: string;
  icd9cm_med_term: number | null;
  icd9cm_term: string;
  medical_description: string;
  type: string;
};

export type Diagnosis = {
  principal?: {
    id: number;
    icd10_code: string;
    icd10_term: string;
    type: string;
  };
  secondary?:
    | {
        id: number;
        icd10_code: string;
        icd10_term: string;
        type: string;
      }[]
    | null;
};

export type RehabDeviceSlotType = {
  devices: Record<string, any>[];
  rehab_order_device: {
    id: number;
    end_date: string;
    end_time: string;
    rehab_device_id: number;
    start_date: string;
    start_time: string;
  }[];
};

export type SelectRehabDeviceSlotType = {
  appointment: Record<string, any>;
  date: string;
  devices: {
    id: number;
    device_free: boolean;
    end_date: string;
    end_time: string;
    name: string;
    rehab_device_id: number;
    rehabilitation_order_id: number;
    start_date: string;
    start_time: string;
  }[];
  division: number;
  items: Record<string, any>[];
  order_id: number;
  order_note: string;
  physiotherapist: number;
  physiotherapist_fullname: string;
};

export type CheckedType = {
  encounter: number;
  no: number;
  plan_item: number;
  plan_item_detail?: any;
};

export type LanguageType = "EN" | "TH";

export type Props = {};

export type State = RehabDevice.State & {
  currentDoctor?: any;
  selectedAppointment?: any;
  buttonLoadCheck?: any;
  django?: any;
  selectedDivision?: any;
  selectedEncounter?: any;
  selectedPatient?: any;
  userTokenize?: any;

  rehabDeviceSlot?: RehabDeviceSlotType;
  rehabExamPlan?: RehabPlanType;
  rehabExamPlanList?: RehabPlanType[];
  rehabHistoryDetail?: RehabHistoryDetailType;
  rehabHistoryList?: RehabOrderType[];
  rehabOrderAppointmentList?: Record<string, any>[];
  // Select from Rehab worklist
  rehabOrderActionLogList?: any[];
  rehabTreatmentList?: RehabPlanType[];
  rehabTreatmentPerform?: RehabOrderType | null;
  rehabTreatmentPerformList?: RehabOrderType[];
  selectedRehabDeviceSlot?: SelectRehabDeviceSlotType | null;
  selectedRehabItems?: Record<string, any>[];
  selectedRehabWorkList?: Record<string, any> | null;
};

export const StateInitial: State = {
  rehabExamPlan: undefined,
  rehabHistoryList: [],
  rehabTreatmentList: [],
  rehabTreatmentPerform: null,
  rehabTreatmentPerformList: [],
};

export type Event =
  | RehabDevice.Event
  | { message: "clearRhbExamPlan"; params: any }
  | { message: "clearRhbHistory"; params: any }
  | { message: "clearRhbTreatment"; params: any }
  | { message: "createUpdateRhbExamPlan"; params: any }
  | { message: "createUpdateRhbImage"; params: any }
  | { message: "deleteRhbOrderItem"; params: any }
  | { message: "deleteRhbPlanItem"; params: any }
  | { message: "getRehabDeviceSlot"; params: any }
  | { message: "getRhbActionLog"; params: any }
  | { message: "getRhbAppointment"; params: any }
  | { message: "getRhbExamPlan"; params: any }
  | { message: "getRhbExamPlanByPatient" }
  | { message: "getRhbHistory"; params: any }
  | { message: "getRhbTreatment"; params: any }
  | { message: "makeAppointmentRhbTreatment"; params: any }
  | { message: "printRhbBookingForm"; params: any }
  | { message: "printRhbPTCertificateForm"; params: any }
  | { message: "selectRehabCombineAppointment"; params: any }
  | { message: "selectRehabHistory"; params: any }
  | { message: "updateRhbExamPlanItem"; params: any }
  | { message: "updateRhbExamPlanItemTotal"; params: any }
  | { message: "updateRhbOrderBillItem"; params: any }
  | { message: "updateRhbTreatmentOrder"; params: any }
  | { message: "updateRhbTreatmentPlan"; params: any };

export type Data = RehabDevice.Data & {
  division: any;
  masterData: any;
};

export const DataInitial = {};

export const LANGUAGE_OPTIONS = [
  { key: "TH", text: "ไทย", value: "TH" },
  { key: "EN", text: "EN", value: "EN" },
];

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

export const createUpdateRhbExamPlan: Handler = async (controller, params) => {
  //   "encounter": 5367,
  // "problem": "1dayleft",
  // "goal": "Updated goal text",
  // "precaution": "Updated precaution text",
  // "order_by": 2,
  // "items": [
  //     {
  //         "product": 294724,
  //         "to_department": 3,
  //         "detail": "Updated plan item detail",
  //         "frequency": 3,
  //         "duration": 5,
  //         "total": 15,
  //         "icd9_type": "PRIMARY",
  //         "medical_description": "Updated medical description",
  //         "icd9cm": 1,
  //         "icd9cm_med_term": 1,
  //         "images": [
  //             {
  //                 "file": ""
  //             }
  //         ]
  //     }
  // ]

  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const [, err] = await CreateUpdateRehabPlan(controller, params);

  if (err) {
    SetErrorMessage(controller, { ...params, error: err });
  } else {
    await getRhbExamPlan(controller);

    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "SUCCESS" },
    });
  }
};

export const updateRhbExamPlanItemTotal: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const [, error] = await RehabPlanItemTotalDetail.update({
    apiToken: controller.apiToken,
    data: { total_for_physiotherapist: params.data.total_for_physiotherapist },
    pk: params.data.id,
  });

  if (error) {
    SetErrorMessage(controller, {
      ...params,
      btnError: null,
      card: "",
      error,
      errorKey: params.card,
    });
  } else {
    await getRhbTreatment(controller);

    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
    });
  }
};

export const updateRhbExamPlanItem: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const [, error] = await RehabPlanItemDetail.patch({
    apiToken: controller.apiToken,
    data: {
      is_continue: params.data.is_continue,
      to_department_for_physiotherapist: params.data.to_department_for_physiotherapist,
    },
    pk: params.data.id,
  });

  if (error) {
    SetErrorMessage(controller, {
      ...params,
      btnError: null,
      card: "",
      error,
      errorKey: params.card,
    });

    return;
  }

  await getRhbTreatment(controller);

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
  });

  params.onSuccess?.();
};

export const deleteRhbOrderItem: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const [, error] = await RehabOrderItemDetail.delete({
    apiToken: controller.apiToken,
    pk: params.id,
  });

  if (error) {
    SetErrorMessage(controller, {
      ...params,
      btnError: null,
      card: "",
      error,
      errorKey: params.card,
    });
  } else {
    await getRhbTreatment(controller);

    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
    });
  }
};

export const deleteRhbPlanItem: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const [, error] = await RehabPlanItemDetail.delete({
    apiToken: controller.apiToken,
    pk: params.id,
    extra: {
      data: { cancel_all: params.cancel_all, canceled_reason: params.canceled_reason },
    },
  });

  if (error) {
    SetErrorMessage(controller, {
      ...params,
      btnError: null,
      card: "",
      error,
      errorKey: params.card,
    });

    return;
  }

  await getRhbTreatment(controller);

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
  });

  params.onSuccess?.();
};

export const getRhbExamPlan: Handler = async (controller) => {
  console.log("getRhbExamPlan: ");

  const combineICDTable = async (rehab: Record<string, any>) => {
    const items: Record<string, any>[] = [];
    const rehabItems: Record<string, any>[] = rehab.items || [];

    if (rehabItems.length > 0) {
      for await (const item of rehabItems) {
        if (item.icd9cm) {
          items.push({
            ...item,
            icd9Data: {
              icd10_id: item.icd9cm,
              icdcode: item.icd9_code,
              icdterm: item.medical_description,
              medterm: item.icd9cm_med_term,
            },
          });
        } else {
          items.push(item);
        }
      }
    }

    return { ...rehab, items };
  };

  const state = controller.getState();

  const [res] = await RehabPlanList.list({
    apiToken: controller.apiToken,
    params: {
      encounter: state.selectedEncounter?.id,
      include_cancel: true,
    },
    extra: { division: controller.data.division },
  });

  const items = res?.items || [];

  let rehab = items[items.length - 1];

  if (rehab) {
    rehab = await combineICDTable(rehab);
  }

  controller.setState({ rehabExamPlan: rehab });
};

export const getRhbExamPlanByPatient: Handler = async (controller) => {
  controller.setState({ rehabExamPlanList: [] });
  
  const state = controller.getState();

  const [res, err, network] = await RehabPlanList.list({
    apiToken: controller.apiToken,
    params: {
      patient: state.selectedPatient?.id,
      exclude_ids: [state.rehabExamPlan?.id],
    },
    extra: { division: controller.data.division },
  });

  if (err) {
    controller.setState({ rehabExamPlanList: [] });
  } else {
    controller.setState({ rehabExamPlanList: res?.items || [] });
  }
}

export const clearRhbExamPlan: Handler = async (controller) => {
  console.log("clearRhbExamPlan: ");

  controller.setState({ rehabExamPlan: undefined });
};

export const getRhbTreatment: Handler = async (controller, params) => {
  const state = controller.getState();

  await controller.handleEvent({
    message: "GetMasterData",
    params: { masters: [["RehabilitationList", {}]] },
  });

  if (params?.btnAction) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [params.btnAction]: "LOADING",
      },
    });
  }

  const [[planRes], [orderRes]] = await Promise.all([
    RehabPlanList.list({
      apiToken: controller.apiToken,
      params: {
        include_cancel: true,
        patient: state.selectedPatient?.id,
      },
      extra: { division: controller.data.division },
    }),
    RehabOrderList.list({
      apiToken: controller.apiToken,
      params: {
        end_date: params?.performEndDate ?? null,
        patient: state.selectedPatient?.id,
        start_date: params?.performStartDate ?? null,
        status_list: ["REQUESTED", "PERFORMED"],
      },
      extra: { division: controller.data.division },
    }),
  ]);

  if (planRes?.items?.length >= 1) {
    const rehab: RehabPlanType[] = planRes?.items || [];
    const orderItems: RehabOrderType[] = orderRes?.items || [];

    const formattedOrderItems = formatOrderItems(
      orderItems,
      rehab,
      controller.data.masterData?.RehabilitationList
    ).filter((item) => item.order_status !== "APPOINTMENT");

    const formattedRehab = rehab.map((plan) => {
      const items: RehabPlanType["items"] = plan.items;

      const formattedItems = items.map((item) => {
        const findRehab = () => {
          const rehabList: Record<string, any>[] =
            controller.data.masterData?.RehabilitationList || [];

          return rehabList.find((acc) => acc.id === item.rehabilitation);
        };

        const findDivision = () => {
          const divisionList: Record<string, any>[] = controller.data.masterData?.division || [];

          return divisionList.find((acc) => acc.id === item.to_department_for_physiotherapist);
        };

        const generateAppointment = (index: number) => {
          const no = index + 1;
          const foundPerformed = item.performed?.find((value) => value.no === no);
          const foundAppointment = item.appointment?.find((value) => value.no === no);

          const findPerformedOrder = () =>
            formattedOrderItems.find((order) => {
              const orders = order.items;

              return orders.some(
                (orderItem) => orderItem.plan_item === item.id && orderItem.no === no
              );
            });

          const performedOrder = findPerformedOrder();
          const isSelected = performedOrder && !foundPerformed?.date;

          return {
            appointment_date: isSelected || foundPerformed?.date ? "" : foundAppointment?.date,
            is_selected: isSelected,
            no,
            performed_date: foundPerformed?.date,
            rehab_order_id: foundPerformed?.rehab_order_id,
          };
        };

        const foundRehab = findRehab();
        const foundDivision = findDivision();

        return {
          ...item,
          appointments: Array.from({ length: item.total_for_physiotherapist }, (unused, index) =>
            generateAppointment(index)
          ),
          divisions: foundRehab?.divisions || [],
          name: foundRehab?.name || "",
          to_department_for_physiotherapist_name: foundDivision?.name || "",
        };
      });

      return {
        ...plan,
        items: formattedItems.filter(
          (acc) => acc.status === "X" || acc.appointments.some((app) => !app.performed_date)
        ),
      };
    });

    formattedRehab.reverse();

    controller.setState({
      rehabTreatmentList: formattedRehab,
      rehabTreatmentPerformList: formattedOrderItems,
    });

    if (state.rehabTreatmentPerform?.id) {
      const selectedOrder = formattedOrderItems.find(
        (order: any) => order.id === state.rehabTreatmentPerform?.id
      );

      const formattedData = formatRehabTreatmentPerform(selectedOrder);

      controller.setState({ rehabTreatmentPerform: formattedData });
    }

    if (params?.btnAction) {
      controller.setState({
        buttonLoadCheck: {
          ...state.buttonLoadCheck,
          [params.btnAction]: "SUCCESS",
        },
      });
    }

    return;
  }

  controller.setState({ rehabTreatmentList: undefined });
};

export const clearRhbTreatment: Handler = async (controller) => {
  console.log("clearRhbTreatment: ");

  controller.setState({ rehabTreatmentList: undefined, rehabTreatmentPerformList: [] });
};

export const updateRhbTreatmentOrder: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  if ("password" in params) {
    const { userId } = await controller.handleEvent({
      message: "CheckUserCredentials" as any,
      params: { ...params, btnKey: params.btnAction, cardKey: params.card },
    });

    if (!userId) {
      return;
    }
  }

  const scanDocData = {
    ScannedDocument_id: params.scannedDocIds || [],
    ScannedDocument_name: params.scannedDocNames || {},
  };

  const payload = {
    ADD_ITEM: {
      api: RehabOrderDetail.update,
      data: {
        action: "ADD_ITEM",
        items: params.items,
      },
    },
    CANCEL: {
      api: RehabOrderDetail.update,
      data: {
        action: "CANCEL",
        canceled_reason: params.canceled_reason,
        canceled_user: state.django?.user?.id,
      },
    },
    EDIT: {
      api: RehabOrderDetail.patch,
      data: { action: "EDIT", data: scanDocData },
    },
    EDIT_PERFORM: {
      api: RehabOrderDetail.patch,
      data: { action: "EDIT_PERFORM", data: scanDocData },
    },
    REQUEST: {
      api: RehabOrderList.create,
      data: {
        action: "REQUEST",
        encounter: state.selectedEncounter?.id,
        items: params.items,
        order_by: state.currentDoctor?.id,
        order_div: state.selectedDivision?.id,
        order_status: "PENDING",
      },
    },
  }[params.action as "ADD_ITEM" | "CANCEL" | "EDIT" | "EDIT_PERFORM" | "REQUEST"];

  const [result, error] = await payload.api({
    apiToken: controller.apiToken,
    data: payload.data,
    pk: params.id,
  } as any);

  if (error) {
    SetErrorMessage(controller, { ...params, btnError: null, error });

    return;
  }

  if (!("password" in params)) {
    await getRhbTreatment(controller);
  }

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
    ...(params.action === "EDIT" &&
      state.rehabTreatmentPerform && {
        rehabTreatmentPerform: { ...state.rehabTreatmentPerform, data: result.data },
      }),
    ...(params.action === "CANCEL" &&
      state.rehabTreatmentPerform?.id === result.id && { rehabTreatmentPerform: null }),
  });

  params.onSuccess?.();
};

export const updateRhbOrderBillItem: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const payload = {
    ADD: {
      api: RehabOrderBillItemList.create,
      data: {
        order: params.order,
        product: null,
      },
    },
    DELETE: {
      id: params.id,
      api: RehabOrderBillItemDetail.delete,
    },
    EDIT: {
      id: params.id,
      api: RehabOrderBillItemDetail.patch,
      data: {
        order: params.order,
        product: params.product,
        quantity: params.quantity || undefined,
      },
    },
    REQUEST: {
      api: RehabOrderBillItemList.create,
      data: {
        order: params.order,
        product: params.product,
        quantity: params.quantity || undefined,
      },
    },
  }[params.action as "ADD" | "DELETE" | "EDIT" | "REQUEST"];

  const [res, error] = await payload.api({
    apiToken: controller.apiToken,
    data: payload.data,
    pk: params.id,
  } as any);

  if (error) {
    const errors = parseErrorString(error);

    SetErrorMessage(controller, {
      ...params,
      btnError: null,
      card: "",
      ...(errors?.__error_type__ === "BILLING_LOCKED"
        ? { error: [errors], errorKey: "ModLockExpense" }
        : { error, errorKey: params.card }),
    });

    return;
  }

  const order = (state.rehabTreatmentPerformList ?? []).map((item) => {
    if (item.id === params.order) {
      if (["EDIT", "REQUEST"].includes(params.action)) {
        item.bill_items[params.index] = res;
      } else if (params.action === "DELETE") {
        item.bill_items.splice(params.index, 1);

        if (item.bill_items.length === 0) {
          item.bill_items = [{ order: null, product: null, quantity: "" }];
        }
      } else if (params.action === "ADD") {
        item.bill_items.push(res);
      }
    }

    return { ...item };
  });

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
    rehabTreatmentPerformList: order,
  });
};

export const updateRhbTreatmentPlan: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const [user] = await UserList.list({
    apiToken: controller.apiToken,
    params: {
      name_code: state.userTokenize?.employeeCode,
    },
  });

  const data = params.data as RehabOrderType;

  const [emr] = await EncounterMedicalRecordList.list({
    apiToken: controller.apiToken,
    pk: data.encounter,
  });

  const emrId = emr?.items[0]?.id;

  const [, error] = await RehabOrderDetail.update({
    apiToken: controller.apiToken,
    data: {
      ...data, // action: "PERFORM",
      order_perform_by: user?.items[0]?.id,
      principal_procedure: data.procedure?.principle
        ? {
            id: data.procedure.principle.id,
            detail: "",
            emr: emrId,
            icd9cm: data.procedure.principle.icd10_id,
            icd9cm_med_term: data.procedure.principle.medterm,
            medical_description: data.procedure.principle.icdterm,
            type: "PRIMARY",
          }
        : null,
      secondary_procedure: (data.procedure?.secondary ?? []).map((item) => ({
        id: item.id,
        detail: "",
        emr: emrId,
        icd9cm: item.icd10_id,
        icd9cm_med_term: item.medterm,
        medical_description: item.icdterm,
        type: "SECONDARY",
      })),
    },
    pk: params.data.id,
  });

  if (error) {
    SetErrorMessage(controller, { ...params, error });
  } else {
    await getRhbTreatment(controller);

    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "SUCCESS" },
      userTokenize: null,
    });
  }
};

export const getRhbActionLog: Handler = async (controller, params) => {
  const [resp, error] = await RehabOrderActionLogList.list({
    apiToken: controller.apiToken,
    pk: params.id,
  });

  if (error) {
    SetErrorMessage(controller, { ...params, error });
  } else {
    controller.setState({ rehabOrderActionLogList: resp?.items || [] });
  }
};

export const getRhbHistory: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const orders = await GetRehabOrderList(controller, {
    ...params,
    filter: {
      end_date: params.filter.endDate,
      start_date: params.filter.startDate,
      status: "PERFORMED",
    },
  });

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "SUCCESS" },
    rehabHistoryList: orders,
  });
};

export const clearRhbHistory: Handler = async (controller) => {
  console.log("clearRhbTreatment: ");

  controller.setState({ rehabHistoryDetail: null, rehabHistoryList: [] });
};

export const selectRehabHistory: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const idList: number[] = params.data?.data?.ScannedDocument_id || [];

  const scanDocParams = {
    // encounter: params.data.encounter,
    id_list: idList,
    patient__hn: state.selectedPatient?.hn,
  };

  if (idList.length === 0) {
    // scanDocParams.encounter = "";
    scanDocParams.patient__hn = "";
  }

  const [[scannedDocRes], [drugItemRes]] = await Promise.all([
    ScannedDocumentList.list({
      apiToken: controller.apiToken,
      params: scanDocParams,
    }),
    DrugOrderItemList.list({
      apiToken: controller.apiToken,
      params: {
        drug_order_type: ["HOME_OPD", "HOME_IPD"],
        encounter: params.data.encounter,
      },
    }),
  ]);

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
    rehabHistoryDetail: {
      ...params.data,
      documents: scannedDocRes?.items || [],
      medications: drugItemRes?.items || [],
    },
  });

  await getRhbTreatment(controller);

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
  });

  params.onSuccess?.();
};

export const getRehabDeviceSlot: Handler = async (controller, params) => {
  const state = controller.getState();

  const [rehabOrder] = await RehabOrderList.list({
    apiToken: controller.apiToken,
    params: { is_appointment: true, patient: state.selectedPatient?.id },
  });

  const orderItems: Record<string, any>[] = rehabOrder?.items || [];
  const foundOrder = orderItems.find(
    (item) => formatDateToYYYYMMDD(params.date) === item.appointment_date
  );

  const [device] = await RehabDeviceSlotList.list({
    apiToken: controller.apiToken,
    params: {
      date: params.date ? beStringToAdString(params.date) : "",
      division: params.division,
      rehab_order: foundOrder?.id,
    },
  });

  controller.setState({ rehabDeviceSlot: device, rehabOrderAppointmentList: orderItems });
};

export const makeAppointmentRhbTreatment: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const items: Record<string, any>[] = params.items;

  let appointment = state.selectedRehabDeviceSlot?.appointment;
  let encounterId = appointment?.order_encounter || state.selectedEncounter?.id;
  let doctorId: number | undefined;
  let doctorName: string | undefined;

  // let encounter: Record<string, any> | null = null;

  if (!encounterId) {
    // ถ้ายังไม่มี encounterId -> สร้าง encounter ใหม่
    const [encounter] = await EncounterList.create({
      apiToken: controller.apiToken,
      data: { action: "OPD_NEW", patient: state.selectedPatient?.id, type: "HID" },
    });

    encounterId = encounter?.id;
  }

  const encounterIds = [...new Set(items.map((item) => item.encounter as number).filter(Boolean))];

  if (encounterIds.length === 1) {
    // ถ้ามี encounter ID เพียงรายการเดียว ให้ดึงข้อมูลแพทย์จาก encounter นั้น
    const [result] = await EncounterDetail.retrieve({
      apiToken: controller.apiToken,
      pk: encounterIds[0],
    });

    doctorId = result?.doctor;
    doctorName = result?.doctor_name;
  }

  // ตรวจสอบว่าเป็นการอัปเดตออร์เดอร์เดิมหรือสร้างออร์เดอร์ใหม่
  const orderId = state.selectedRehabDeviceSlot?.order_id;
  const api = orderId ? RehabOrderDetail.update : RehabOrderList.create;

  // สร้าง RehabOrder (ส่งคำขอรักษา)
  const [result, error] = await api({
    apiToken: controller.apiToken,
    data: {
      action: orderId ? "EDIT" : "REQUEST",
      devices: params.devices,
      encounter: encounterId,
      items: items.map((item) => ({
        ...item,
        diagnosis: undefined,
        plan_item_detail: undefined,
      })),
      order_by: state.currentDoctor?.id,
      order_div: params.division,
      order_status: "APPOINTMENT",
      physiotherapist: params.physiotherapist,
    },
    pk: orderId,
  });

  if (error) {
    SetErrorMessage(controller, { ...params, error });

    return;
  }

  if (!appointment?.id) {
    // สร้างนัดหมาย (appointment) จาก rehab order ที่เพิ่งสร้าง
    [appointment] = await PatientAppointmentView.create({
      apiToken: controller.apiToken,
      data: {
        date: result.device_date,
        division: state.selectedDivision?.id,
        encounter_id: encounterId,
        end_time: result.device_end_time,
        is_rehab: true,
        patient: state.selectedPatient?.id,
        start_time: result.device_start_time,
      } as any,
    });
  }

  // อัปเดตข้อมูลเพิ่มเติมลงใน appointment ที่สร้าง -> note, extra
  const [update] = await PatientAppointmentUpdate.patch({
    apiToken: controller.apiToken,
    data: {
      division: params.division,
      estimated_at_iso: `${result.device_date} ${result.device_start_time}`,
      order_dict: { [result.id]: "rehabilitationorder" },
      order_note: params.order_note,
      repetition_note: "-",
      extra: {
        ...appointment?.extra,
        date: result.device_date,
        end_time: result.device_end_time,
        start_time: result.device_start_time,
        ...(result.physiotherapist && {
          physiotherapist: result.physiotherapist,
          physiotherapist_fullname: result.physiotherapist_fullname,
        }),
        ...(doctorId && {
          doctor: doctorId,
          doctor_full_name: doctorName,
        }),
      },
    } as any,
    pk: appointment?.id,
  });

  await getRhbTreatment(controller);

  // แก้ไขข้อมูลนัดเพิ่มเติม -> เวลานัด, แพทย์
  await AppointmentDetail.patch({
    apiToken: controller.apiToken,
    data: {
      action: "EDIT",
      date: formatDate(moment(result.device_date)),
      division: appointment?.division,
      doctor: doctorId,
      end_time: moment(`${result.device_date} ${result.device_end_time}`).format("HH:mm"),
      start_time: moment(`${result.device_date} ${result.device_start_time}`).format("HH:mm"),
    } as any,
    pk: appointment?.content_id,
    extra: { division: appointment?.order_division },
  });

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
  });

  params.onSuccess?.({ appointment: update });
};

export const getRhbAppointment: Handler = async (controller, params) => {
  const state = controller.getState();

  if (!state.buttonLoadCheck?.[params.card]) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [params.card]: "LOADING" },
    });
  }

  if (!params.orderId) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [params.card]: "SUCCESS" },
    });

    return;
  }

  const extra = params.appointment?.extra;
  const date = extra?.date ? beStringToAdString(formatDate(moment(extra.date))) : "";

  const [orders, devices] = await Promise.all([
    GetRehabOrderList(controller, params),
    GetRehabDeviceListList(controller, {
      date,
      division: params.appointment?.division,
      orderId: params.orderId,
    }),
  ]);

  const items = (orders as Record<string, any>[]).flatMap(
    (order) => order.items as Record<string, any>[]
  );

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.card]: "SUCCESS" },
    selectedRehabDeviceSlot: {
      devices,
      division: params.appointment?.division,
      items,
      order_id: params.orderId,
      order_note: params.appointment?.order_note,
      ...extra,
      appointment: params.appointment,
    },
    selectedRehabItems: items,
  });
};

export const printRhbBookingForm: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const items = params.items as CheckedType[];
  const orderIds = new Set(
    items.map((item) => {
      const appointment: RehabPlanItemDetailType["appointment"] = item.plan_item_detail.appointment;

      return appointment?.find((acc) => acc.no === item.no)?.rehab_order_id;
    })
  );

  const [result] = await PatientAppointmentView.list({
    apiToken: controller.apiToken,
    params: {
      appointment_related_type: "REHAB",
      patient_id: state.selectedPatient?.id,
      type: 1273,
    },
  });

  const appointmentItems: Record<string, any>[] = result?.items || [];
  const filterAppointments = appointmentItems.flatMap((app) => {
    const orders: Record<string, any>[] = app.orders || [];
    const foundOrder = orders.find((order) => orderIds.has(order.id));

    return foundOrder
      ? [
          {
            estimated_at_iso: app.estimated_at_iso,
            order_note: app.order_note,
            physiotherapist_fullname: app.extra?.physiotherapist_fullname,
            summary_detail: foundOrder.summary_detail,
          },
        ]
      : [];
  });

  const [staff] = await UserEmployeeDetailAPIView.retrieve({
    apiToken: controller.apiToken,
    pk: state.django?.user?.id,
  });

  const patient = state.selectedPatient;

  const patientDateInfo = calculateAgeAndDOB(patient.full_age);

  const genderMapping: Record<string, any> = {
    EN: { F: "Female", M: "Male" },
    TH: { F: "หญิง", M: "ชาย" },
  };

  const docDef = await FormPhysicalTherapySchedule({
    appointments: filterAppointments,
    language: params.language,
    ...(params.language === "TH"
      ? {
          patient: {
            age: patientDateInfo.fullage_th,
            birthdate: patientDateInfo.birthdate_th,
            hn: patient.hn,
            name: patient.full_name_th,
            sex: genderMapping.TH[patient.gender] || "N/A",
          },
          printed_by: GetStaffName(controller as any, { staff, type: "th" }),
        }
      : {
          patient: {
            age: patientDateInfo.fullage_en,
            birthdate: patientDateInfo.birthdate_en,
            hn: patient.hn,
            name: patient.full_name_en,
            sex: genderMapping.EN[patient.gender] || "N/A",
          },
          printed_by: GetStaffName(controller as any, { staff, type: "en" }),
        }),
  });

  const pdfMake = await getPdfMake(true);
  const pdf = pdfMake.createPdf(docDef);

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "SUCCESS" },
  });

  pdf.open();
};

export const printRhbPTCertificateForm: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  await controller.handleEvent({
    message: "GetMasterData",
    params: {
      masters: [
        ["prenameTh", {}],
        ["prenameEn", {}],
      ],
    },
  });

  const data = state.rehabHistoryDetail;
  const patient = state.selectedPatient;
  const medications = data?.medications ?? [];
  const masterData = controller.data.masterData;

  const [[enDetail], [adr], [staff], [constance], [userDetail], [userEmployee]] = await Promise.all(
    [
      EncounterDetail.retrieve({
        apiToken: controller.apiToken,
        pk: data?.encounter,
      }),
      AdverseReactionList.list({
        apiToken: controller.apiToken,
        params: { exclude_unused: true, patient: patient.id, severe_first: true },
      }),
      UserEmployeeDetailAPIView.retrieve({
        apiToken: controller.apiToken,
        pk: state.django?.user?.id,
      }),
      ConstanceView.get({
        apiToken: controller.apiToken,
        params: { list: "core_HOSPITAL_NAME_EN" },
        extra: { division: controller.data.division },
      }),
      UserDetailAPIView.retrieve({
        apiToken: controller.apiToken,
        pk: data?.order_perform_by,
      }),
      UserEmployeeDetailAPIView.retrieve({
        apiToken: controller.apiToken,
        pk: data?.order_perform_by,
      }),
    ]
  );

  let performByFullname = data?.order_perform_by_fullname || "";
  let certificateNo = "";

  if (userDetail?.doctor) {
    const [doctor] = await DoctorDetail.retrieve({
      apiToken: controller.apiToken,
      pk: userDetail?.doctor,
    });

    const formattedDoctor = formatDoctorName(doctor, masterData);

    performByFullname = formattedDoctor.en || formattedDoctor.th;
    certificateNo = formattedDoctor.certificateNo;
  } else {
    certificateNo = userEmployee?.licence || "";
  }

  const principleProcedure = data?.principal_procedure?.icd9cm
    ? `[${data.principal_procedure.icd9cm_code}] ${data.principal_procedure.icd9cm_term}`
    : "-";

  const divisions: Record<string, any>[] = masterData.division ?? [];
  const foundDiv = divisions.find((div) => div.id === data?.out_perform_div);

  const docDef = await FormPhysicalTherapyCertificate({
    detail: {
      ...patient,
      adrText: formatAllergy(adr?.items ?? []),
      number: data?.encounter_number,
      patient_age: patient.full_age,
      patient_birthdate: patient.birthdate,
      patient_gender_name: patient.gender_name,
      patientNameEN: patient.full_name_en,
      patientNameTH: patient.full_name_th,
      visitDate: formatDate(moment(enDetail?.started)),
    },
    divisionName: `${foundDiv?.name || ""}, ${constance?.result?.core_HOSPITAL_NAME_EN || ""}`,
    examination: {
      assessment: data?.assessment || "-",
      goal: data?.goal || "-",
      objective: data?.objective || "-",
      other_examination: data?.other_examination || "-",
      subjective: data?.subjective || "-",
    },
    finish: data?.finish || "",
    license: certificateNo,
    medications,
    order_perform_by_fullname: performByFullname,
    post_treatment_evaluation: data?.post_treatment_evaluation || "-",
    principleProcedure,
    printed_by: GetStaffName(controller as any, { staff, type: "en" }),
    recommendation_education: data?.recommendation_education || "-",
    result: data?.result || "-",
    secondaryProcedure: [...params.secondaryProcedure],
    start: data?.start || "",
    treatmentOrders: [...params.treatmentOrders],
  });

  const pdfMake = await getPdfMake(true);
  const pdf = pdfMake.createPdf(docDef);

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "SUCCESS" },
  });

  pdf.open();
};

export const selectRehabCombineAppointment: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const appointmentId = params.original?.patient_appointment_id?.[0];
  const orderId = params.original?.id;

  if (!appointmentId) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
      selectedRehabDeviceSlot: null,
    });

    return;
  }

  const [appRes, appError] = await PatientAppointmentUpdate.retrieve({
    apiToken: controller.apiToken,
    pk: appointmentId,
  });

  if (appError) {
    SetErrorMessage(controller, { ...params, error: appError });

    return;
  }

  const data = appRes.extra;
  const division = appRes.division;
  const orderNote = appRes.order_note;

  const date = data?.date ? beStringToAdString(formatDate(moment(data.date))) : "";

  const [orders, devices] = await Promise.all([
    GetRehabOrderList(controller, { ...params, orderId }),
    GetRehabDeviceListList(controller, { date, division, orderId }),
  ]);

  const items = (orders as Record<string, any>[]).flatMap(
    (order) => order.items as Record<string, any>[]
  );

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
    selectedRehabDeviceSlot: {
      devices,
      division,
      items: [...items, ...params.checkedList],
      order_id: orderId,
      order_note: orderNote,
      ...data,
      appointment: appRes,
    },
  });
};

export const createUpdateRhbImage: Handler = async (controller, params) => {
  const planItems: Record<string, any>[] = params.planItems || [];

  const formattedItems: RehabPlanType["items"] = params.formattedItems || [];

  const formattedImages = planItems.map((item, index) => ({
    items: (formattedItems[index]?.images ?? [])
      .map((image) => ({
        id: image.id,
        file: image.file,
        file_name: image.file_name,
        image: image.image,
      }))
      .filter((image) => {
        const isNewItem = params.isCreate ? !formattedItems[index].id : true;

        return typeof image.image !== "string" && isNewItem;
      }),
    pk: item.id,
  }));

  const filteredImages = formattedImages.filter((item) => item.items.length > 0);

  const promiseArr = filteredImages.map(
    async (item) =>
      RehabImageDetail.update({
        apiToken: controller.apiToken,
        data: item.items,
        pk: item.pk,
      }) as Promise<any[]>
  );

  return Promise.all(promiseArr);
};

// APIs
const GetRehabOrderList: Handler = async (controller, params) => {
  const state = controller.getState();

  await controller.handleEvent({
    message: "GetMasterData",
    params: { masters: [["RehabilitationList", {}]] },
  });

  const api = params.orderId ? RehabOrderDetail.retrieve : RehabOrderHistoryList.list;

  const [[planRes, planError], [orderRes, orderError]] = await Promise.all([
    RehabPlanList.list({
      apiToken: controller.apiToken,
      params: {
        patient: state.selectedPatient?.id,
      },
      extra: { division: controller.data.division },
    }),
    api({
      apiToken: controller.apiToken,
      params: {
        patient: state.selectedPatient?.id,
        ...params.filter,
      },
      pk: params.orderId,
      extra: { division: controller.data.division },
    }),
  ]);

  if (planError || orderError) {
    SetErrorMessage(controller, { ...params, error: planError ?? orderError });

    return [];
  }

  const planItems: RehabPlanType[] = planRes?.items || [];
  const orderItems: RehabOrderType[] = params.orderId ? [orderRes] : orderRes?.items || [];

  return formatOrderItems(orderItems, planItems, controller.data.masterData?.RehabilitationList);
};

const GetRehabDeviceListList: Handler = async (controller, params) => {
  const [result] = await RehabDeviceSlotList.list({
    apiToken: controller.apiToken,
    params: { date: params.date, division: params.division, rehab_order: params.orderId },
  });

  const rehabOrderDevice: Record<string, any>[] = result?.rehab_order_device || [];
  const devices: Record<string, any>[] = result?.devices || [];
  const filteredDevices = rehabOrderDevice.filter(
    (item) => item.rehabilitation_order_id === params.orderId
  );

  return filteredDevices.map((item) => {
    const foundDevice = devices.find((device) => device.id === item.rehab_device_id);

    return {
      ...item,
      device_free: foundDevice?.device_free ?? false,
      name: foundDevice?.name || "",
    };
  });
};

const CreateUpdateRehabPlan: Handler = async (controller, params) => {
  const state = controller.getState();

  const items: RehabPlanType["items"] = params.items || [];

  const formattedItems = items.map((item) => ({
    ...item,
    // detail: item.detail,
    // duration: item.duration,
    // frequency: item.frequency,
    // icd9_type: item.icd9_type,
    medical_description: item.icd9Data?.icdterm,
    // rehabilitation: item.rehabilitation,
    // to_department: item.to_department,
    // total: item.total,
    ...(item.icd9Data?.icd10_id ? { icd9cm: item.icd9Data.icd10_id } : {}),
    ...(item.icd9Data?.medterm_id ? { icd9cm_med_term: item.icd9Data.medterm_id } : {}),
    images: item.images ?? [],
    // แก้ไขข้อมูลแทนที่ของนักกายเมื่อแพทย์มีการเปลี่ยนแปลงข้อมูล
    ...((!item.to_department_for_physiotherapist || item.to_department_for_doctor_changed) && {
      to_department_for_physiotherapist: item.to_department_for_doctor,
    }),
    ...((!item.total_for_physiotherapist || item.total_for_doctor_changed) && {
      total_for_physiotherapist: item.total_for_doctor,
    }),
  }));

  const api = params?.id ? RehabPlanDetail.update : RehabPlanList.create;

  const [res, err] = await api({
    apiToken: controller.apiToken,
    data: {
      encounter: state.selectedEncounter?.id,
      goal: params.goal,
      items: formattedItems.map((item) => ({ ...item, images: undefined })),
      order_by: params.order_by,
      order_receive_by: params.order_receive_by,
      precaution: params.precaution,
      problem: params.problem,
    },
    pk: params.id,
    extra: { division: controller.data.division },
  });

  if (err) {
    return [null, err] as [null, unknown];
  }

  await createUpdateRhbImage(controller, { formattedItems, isCreate: true, planItems: res.items });

  return [res, err] as [Record<string, any>, unknown];
};

// Utils
const formatOrderItems = (
  orderItems: RehabOrderType[],
  planItems: RehabPlanType[],
  rehabItems: Record<string, any>[] = []
) => {
  // ฟังก์ชันสำหรับหา planItem และ planDetail
  const findPlanDetails = (planItemId: number) => {
    const planItem = planItems.find((plan) => plan.items.some((acc) => acc.id === planItemId));

    const planDetail = planItem?.items.find((acc) => acc.id === planItemId);

    return { planDetail, planItem };
  };

  const findRehabItem = (rehabId: number) => rehabItems.find((acc) => acc.id === rehabId);

  const formatOrderItem = (item: RehabOrderType["items"][number], order: RehabOrderType) => {
    const { planDetail, planItem } = findPlanDetails(item.plan_item);
    const foundItem = planDetail ? findRehabItem(planDetail.rehabilitation) : null;

    return {
      ...item,
      diagnosis: planItem?.diagnosis,
      encounter: order.encounter,
      plan_item_detail: planDetail ? { ...planDetail, name: foundItem?.name || "" } : undefined,
    };
  };

  return orderItems.map((order) => ({
    ...order,
    // default bill items เมื่อยังไม่ได้สร้าง bill items
    bill_items:
      order.bill_items.length > 0
        ? order.bill_items
        : [{ order: null, product: null, quantity: "" }],
    items: order.items.map((item) => formatOrderItem(item, order)),
    order_status: order.order_status,
  }));
};

export const formatRehabImage = (images: RehabImageType[]) => {
  const overlayImages = images.filter(
    (image) => String(image.image).includes("overlay") || image.is_overlay
  );
  const originalImages = new Set(
    images.filter((image) => String(image.image).includes("original") || image.is_original)
  );

  const overlay = [
    {
      image: Object.fromEntries(
        overlayImages.map((image) => [image.file_name || "", image.file || image.image])
      ),
    },
  ];

  const activePanesData = [...originalImages].map((image, index) => {
    const foundOverlay: RehabImageType | undefined = overlayImages.find(
      (item) => item.file_name === image.file_name
    );

    return {
      id: image.id,
      editable: index > 0,
      image: image.file || image.image,
      key: image.file_name,
      name: image.file_name,
      overlay: foundOverlay?.image || null,
      overlay_id: foundOverlay?.id ?? null,
      removable: index > 0,
    };
  });

  return { activePanes: activePanesData, imageOverlay: overlay };
};

export const formatRehabTreatmentPerform = (order: RehabOrderType | null = null) => {
  if (!order) {
    return null;
  }

  const principles = order.items.filter(
    (item) => item.plan_item_detail?.icd9_type === "PRIMARY" && item.plan_item_detail.icd9cm
  );
  const secondaries = order.items.filter(
    (item) => item.plan_item_detail?.icd9_type === "SECONDARY" && item.plan_item_detail.icd9cm
  );

  const secondarySet = new Set();
  const uniqueSecondaryItems = secondaries.filter((item) =>
    secondarySet.has(item.plan_item_detail?.icd9cm)
      ? false
      : secondarySet.add(item.plan_item_detail?.icd9cm)
  );

  const principle = principles[0]?.plan_item_detail;

  const procedure = order.order_perform_by
    ? {
        principle: order.principal_procedure?.id
          ? {
              icd10_id: order.principal_procedure.icd9cm,
              icdcode: order.principal_procedure.icd9cm_code,
              icdterm: order.principal_procedure.medical_description,
              medterm: order.principal_procedure.icd9cm_med_term,
            }
          : null,
        secondary: (order.secondary_procedure ?? []).map((item) => ({
          icd10_id: item.icd9cm,
          icdcode: item.icd9cm_code,
          icdterm: item.medical_description,
          medterm: item.icd9cm_med_term,
        })),
      }
    : {
        principle:
          principles.length === 1 && principle
            ? {
                icd10_id: principle.icd9cm,
                icdcode: principle.icd9_code,
                icdterm: principle.medical_description,
                medterm: principle.icd9cm_med_term,
              }
            : null,
        secondary: uniqueSecondaryItems.map((item) => ({
          icd10_id: item.plan_item_detail?.icd9cm ?? null,
          icdcode: item.plan_item_detail?.icd9_code || "",
          icdterm: item.plan_item_detail?.medical_description || "",
          medterm: item.plan_item_detail?.icd9cm_med_term ?? null,
        })),
      };

  const now = moment();

  return {
    ...order,
    ...(order.finish
      ? {
          endDate: formatDate(moment(order.finish)),
          endTime: moment(order.finish).format("HH:mm"),
        }
      : {
          endDate: formatDate(now),
          endTime: "",
        }),
    procedure,
    ...(order.start
      ? {
          startDate: formatDate(moment(order.start)),
          startTime: moment(order.start).format("HH:mm"),
        }
      : { startDate: formatDate(now), startTime: now.format("HH:mm") }),
  };
};

const parseErrorString = (errors: Record<string, any> | string[] | null) => {
  try {
    if (Array.isArray(errors)) {
      const errorString: string = errors[0];
      const match = /\{.*\}/.exec(errorString);
      const jsonPart = match?.[0] || "";

      if (!jsonPart) {
        console.error("No JSON found in error string");

        return errors;
      }

      // แปลง Python format เป็น JSON
      let cleanedJson = jsonPart
        .replaceAll("'", '"')
        .replaceAll("True", "true")
        .replaceAll("False", "false")
        .replaceAll("None", "null");

      // จัดการ OrderedDict - แปลงเป็น object
      cleanedJson = cleanedJson.replaceAll(
        /OrderedDict\(\[(.*?)\]\)/g,
        (unused, content: string) => {
          const pairs = (content || "").match(/\([^)]+\)/g) ?? [];
          const object = pairs
            .map((pair) => {
              const cleaned = pair.replaceAll(/[()]/g, "");
              const [key, value] = cleaned.split(", ", 2);

              return `${key}: ${value}`;
            })
            .join(", ");

          return `{${object}}`;
        }
      );

      return JSON.parse(cleanedJson) as Record<string, any>;
    }

    return errors;
  } catch {
    return errors;
  }
};

export const getFilteredDivisions = (
  allDivisionList: Record<string, any>[] = [],
  selectedDivisions?: number[]
) =>
  allDivisionList
    .filter((item) => {
      if (!item.is_active || !selectedDivisions) {
        return false;
      }

      if (selectedDivisions.length === 0) {
        return true;
      }

      return selectedDivisions.includes(item.id);
    })
    .map((item) => ({ key: item.id, text: item.name, value: item.id }));
